module.exports = __webpack_public_path__ + "static/img/far2.49a34781.png";